module.exports = __webpack_public_path__ + "static/needs-clipped-9e0ce0acaca3986eb78b10227f549bdc.png";